import View from './View'

const Container = () => <View title="Menu User" />

export default Container
